<template>
  <div class="hello" style="background-color: #fff; min-height: 100vh">
    <div style="padding: 20px 20px">
      <van-tabs v-model="active" color="#58AAFF">
        <van-tab title="绿榜项目">
          <!-- 年份下拉表 -->
          <van-row type="flex" justify="end">
            <van-col span="4">
              <select
                v-model="selectYearLbxm"
                @change="selectChangeLbxm($event)"
                class="selectClass"
              >
                <option
                  v-for="(item, index) in selectYearsColumns"
                  :key="index"
                  :value="item"
                >
                  {{ item }}
                </option>
              </select>
            </van-col>
          </van-row>
          <van-row type="flex" justify="space-between" style="flex-wrap: wrap">
            <van-col
              span="11"
              :style="'background-color: #2ECCBD;border-radius: 4px;margin-top: 20px; height: 70px; padding: 6px 6px;'"
              v-for="(item, index) in seasonList"
              :key="index"
              @click="clickLbxmSeason(index + 1)"
            >
              <div
                style="
                  font-size: 12px;
                  font-weight: 400;
                  color: #fff;
                  text-align: center;
                  padding-top: 20px;
                "
              >
                {{ item }}
              </div>
            </van-col>
          </van-row>
        </van-tab>
        <!-- <van-tab title="滞后项目">
          <div class="zhxmTitlecls">
            滞后项目数量：{{ ngProjects.length }}项
          </div>
          <van-collapse v-model="activeZhxm" accordion>
            <van-collapse-item
              :name="index"
              v-for="(item, index) in ngProjects"
              :key="index"
            >
              <div slot="title" style="text-align: left; color: #000">
                {{ item.currentXmmc }}
              </div>
              <div class="zhxmTextCls" @click="clickMethod(item)">
                <div>项目名称：</div>
                <p>{{ item.xmmc || '-' }}</p>
                <div>牵头单位：</div>
                <p>{{ item.deptName || '-' }}</p>
                <div>滞后情况：</div>
                <p>{{ item.lag || '-' }}</p>
                <div>下步计划：</div>
                <p>{{ item.next || '-' }}</p>
              </div>
            </van-collapse-item>
          </van-collapse>
        </van-tab> -->
        <!-- <van-tab title="考核得分">
          <van-row type="flex" justify="end">
            <van-col span="4">
              <select v-model="selectYearAllScore" @change="selectChangeKhdf($event)" class="selectClass" >
                <option v-for="(item,index) in selectYearsColumns" :key="index" :value="item">
                    {{item}}
                </option>
              </select>
            </van-col>
          </van-row>
          <van-row type="flex" justify="space-between" style="flex-wrap: wrap;">
            <van-col span="24" :style="'background-color: #55A9FF;border-radius: 4px;margin-top: 20px; height: 70px; padding: 6px 6px;'" @click="clickScoreSeason(5)">
              <div style="font-size: 12px; font-weight: 400;color: #fff; text-align: center; padding-top: 20px;">全年度</div>
            </van-col>
          </van-row>
          <van-row type="flex" justify="space-between" style="flex-wrap: wrap;">
            <van-col span="11" :style="'background-color: #2ECCBD;border-radius: 4px;margin-top: 20px; height: 70px; padding: 6px 6px;'" v-for="item,index in seasonList" :key="index" @click="clickScoreSeason(index + 1)">
              <div style="font-size: 12px; font-weight: 400;color: #fff; text-align: center; padding-top: 20px;">{{item}}</div>
            </van-col>
          </van-row>
        </van-tab> -->
      </van-tabs>
      <van-dialog
        v-model="showMrzx"
        :showConfirmButton="false"
        style="width: 95%; height: calc(100% - 90px)"
      >
        <div
          style="
            height: 35px;
            padding-top: 5px;
            font-size: x-large;
            color: cadetblue;
          "
        >
          {{ dateTitle }}
        </div>
        <div
          style="
            width: 100%;
            height: calc(100% - 80px);
            position: fixed;
            overflow: scroll;
          "
        >
          <van-row
            type="flex"
            justify="space-between"
            style="padding-top: 20px; margin: 0px 5px 0px 0px"
            v-for="(item, index) in persons"
            :key="index"
          >
            <van-col span="10" style="padding-top: 10px">
              <van-image
                width="100px"
                height="100px"
                fit="cover"
                radius="50%"
                :src="item.url"
              />
            </van-col>
            <van-col span="14">
              <div
                style="
                  font-size: 18px;
                  font-weight: 600;
                  color: #000;
                  text-align: left;
                "
              >
                {{ item.name }}
              </div>
              <div
                style="
                  font-size: 10px;
                  font-weight: 200;
                  color: #000;
                  text-align: left;
                  padding-top: 8px;
                "
              >
                {{ item.jj }}
              </div>
            </van-col>
          </van-row>
          <div style="height: 20px; color: darkgoldenrod">
            {{ persons.length == 0 ? '暂无数据' : '' }}
          </div>
        </div>
        <div
          style="
            position: absolute;
            bottom: 0px;
            width: 100%;
            height: 45px;
            line-height: 45px;
            background-color: #007acc;
          "
          @click="showMrzx = false"
        >
          关闭
        </div>
      </van-dialog>
      <van-dialog
        v-model="showScore"
        :showConfirmButton="false"
        class="deepMaxHeight"
        style="
          width: 95%;
          height: calc(100% - 90px);
          box-sizing: border-box;
          padding: 0 15px;
        "
      >
        <div
          style="
            height: 35px;
            padding-top: 5px;
            font-size: x-large;
            color: cadetblue;
          "
        >
          {{ dateTitle }}
        </div>
        <!-- 名称类型下拉列表 -->
        <van-row type="flex" justify="end">
          <van-col span="4">
            <select
              v-model="unitType"
              @change="selectChangeunitFn($event)"
              class="selectClass"
            >
              <option
                v-for="(item, index) in unitTypeList"
                :key="index"
                :value="item.value"
              >
                {{ item.name }}
              </option>
            </select>
          </van-col>
        </van-row>
        <div style="width: 100%; height: calc(100% - 80px); overflow: scroll">
          <van-row style="padding: 20px 0px">
            <van-col span="12">
              <van-tag color="#2ECABC" style="padding: 5px">名称</van-tag>
            </van-col>
            <van-col span="12">
              <van-tag color="#2ECABC" style="padding: 5px">总分</van-tag>
            </van-col>
            <!-- <van-col span="5">
              <van-tag color="#2ECABC" style="padding: 5px;">项目得分</van-tag>
            </van-col>
            <van-col span="5">
              <van-tag color="#2ECABC" style="padding: 5px;">附加分</van-tag>
            </van-col> -->
          </van-row>
          <van-row
            gutter="10"
            type="flex"
            justify="space-between"
            style="padding-bottom: 10px; border-bottom: 1px solid #e8e8e8"
            v-for="(item6, index6) in scoreProjects"
            :key="index6 + '_6'"
          >
            <van-col span="12">
              <div
                style="
                  font-size: 14px;
                  font-weight: 400;
                  color: #000;
                  text-align: center;
                  padding-top: 8px;
                "
              >
                {{ item6.deptName }}
              </div>
            </van-col>
            <van-col span="12">
              <div
                style="
                  font-size: 14px;
                  font-weight: 400;
                  color: #000;
                  text-align: center;
                  padding-top: 8px;
                "
              >
                {{ item6.zf }}
              </div>
            </van-col>
            <!-- <van-col span="5">
              <div style="font-size: 14px; font-weight: 400;color: #000; text-align: center; padding-top: 8px;">{{item6.xmjqdf}}</div>
            </van-col>
            <van-col span="5">
              <div style="font-size: 14px; font-weight: 400;color: #000; text-align: center; padding-top: 8px;">{{item6.jdfjf}}</div>
            </van-col> -->
          </van-row>
          <div style="height: 20px; color: darkgoldenrod">
            {{ scoreProjects.length == 0 ? '暂无数据' : '' }}
          </div>
        </div>
        <div
          style="
            position: absolute;
            left: 0;
            bottom: 0px;
            width: 100%;
            height: 45px;
            line-height: 45px;
            background-color: #007acc;
          "
          @click="showScore = false"
        >
          关闭
        </div>
      </van-dialog>
      <van-dialog v-model="showScoreDetail">
        <van-row
          type="flex"
          style="
            text-align: left;
            font-size: 14px;
            color: #000;
            padding: 30px 20px 0px 20px;
            flex-wrap: wrap;
          "
        >
          <van-col span="24" style="font-size: 14px; font-weight: 600"
            >主要内容：</van-col
          >
          <van-col
            span="24"
            style="font-size: 14px; font-weight: 200; padding: 10px 0px 0px 0px"
            >{{ showDetail.zynr }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          style="
            text-align: left;
            font-size: 14px;
            color: #000;
            padding: 10px 20px 0px 20px;
            flex-wrap: wrap;
          "
        >
          <van-col span="8" style="font-size: 14px; font-weight: 600"
            >项目名称：</van-col
          >
          <van-col
            span="16"
            style="font-size: 14px; font-weight: 200; padding: 0px 0px 0px 0px"
            >{{ showDetail.name }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          style="
            text-align: left;
            font-size: 14px;
            color: #000;
            padding: 10px 20px 0px 20px;
            flex-wrap: wrap;
          "
        >
          <van-col span="8" style="font-size: 14px; font-weight: 600"
            >牵头单位：</van-col
          >
          <van-col
            span="16"
            style="font-size: 14px; font-weight: 200; padding: 0px 0px 0px 0px"
            >{{ showDetail.dept }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          style="
            text-align: left;
            font-size: 14px;
            color: #000;
            padding: 10px 20px 0px 20px;
            flex-wrap: wrap;
          "
        >
          <van-col span="8" style="font-size: 14px; font-weight: 600"
            >得分：</van-col
          >
          <van-col
            span="16"
            style="font-size: 14px; font-weight: 200; padding: 0px 0px 0px 0px"
            >{{ showDetail.score }}分</van-col
          >
        </van-row>
      </van-dialog>
      <van-dialog
        v-model="showLbxm"
        :showConfirmButton="false"
        style="width: 95%; height: calc(100% - 90px)"
      >
        <div
          style="
            height: 35px;
            padding-top: 5px;
            font-size: x-large;
            color: cadetblue;
          "
        >
          {{ dateTitle }}
        </div>
        <div
          style="
            width: 100%;
            height: calc(100% - 80px);
            position: fixed;
            overflow: scroll;
          "
        >
          <van-row style="padding-top: 20px">
            <van-col span="12">
              <van-tag color="#2ECABC" style="padding: 5px 20px"
                >项目名称</van-tag
              >
            </van-col>
            <van-col span="12">
              <van-tag color="#2ECABC" style="padding: 5px 20px"
                >牵头单位</van-tag
              >
            </van-col>
          </van-row>
          <van-row
            type="flex"
            justify="space-between"
            style="padding-top: 20px"
            v-for="(item1, index1) in okProjects"
            :key="index1"
            @click="showSbly(item1)"
          >
            <van-col span="11">
              <div
                style="
                  font-size: 14px;
                  font-weight: 400;
                  color: #000;
                  text-align: center;
                  padding-top: 8px;
                "
              >
                {{ item1.name }}
              </div>
            </van-col>
            <van-col span="11">
              <div
                style="
                  font-size: 14px;
                  font-weight: 400;
                  color: #000;
                  text-align: center;
                  padding-top: 8px;
                "
              >
                {{ item1.dept }}
              </div>
            </van-col>
          </van-row>
          <div style="height: 20px; color: darkgoldenrod">
            {{ okProjects.length == 0 ? '暂无数据' : '' }}
          </div>
        </div>
        <div
          style="
            position: absolute;
            bottom: 0px;
            width: 100%;
            height: 45px;
            line-height: 45px;
            background-color: #007acc;
          "
          @click="showLbxm = false"
        >
          关闭
        </div>
      </van-dialog>
      <van-dialog v-model="showlbxmDetail">
        <van-row
          type="flex"
          style="
            text-align: right;
            font-size: 14px;
            color: #000;
            padding: 10px 20px 0px 20px;
            flex-wrap: wrap;
          "
        >
          <van-col
            span="24"
            style="font-size: 14px; font-weight: 600; color: #007acc"
            @click="clickMethod(lbxmItem)"
            >查看详细</van-col
          >
        </van-row>
        <van-row
          type="flex"
          style="
            text-align: left;
            font-size: 14px;
            color: #000;
            padding: 10px 20px 0px 20px;
            flex-wrap: wrap;
          "
        >
          <van-col span="8" style="font-size: 14px; font-weight: 600"
            >项目名称：</van-col
          >
          <van-col
            span="16"
            style="font-size: 14px; font-weight: 200; padding: 0px 0px 0px 0px"
            >{{ lbxmDetail.name }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          style="
            text-align: left;
            font-size: 14px;
            color: #000;
            padding: 10px 20px 0px 20px;
            flex-wrap: wrap;
          "
        >
          <van-col span="8" style="font-size: 14px; font-weight: 600"
            >牵头单位：</van-col
          >
          <van-col
            span="16"
            style="font-size: 14px; font-weight: 200; padding: 0px 0px 0px 0px"
            >{{ lbxmDetail.dept }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          style="
            text-align: left;
            font-size: 14px;
            color: #000;
            padding: 10px 20px 0px 20px;
            flex-wrap: wrap;
          "
        >
          <van-col span="8" style="font-size: 14px; font-weight: 600"
            >上榜理由：</van-col
          >
          <van-col
            span="16"
            style="font-size: 14px; font-weight: 200; padding: 0px 0px 0px 0px"
            >{{ lbxmDetail.sbly }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          style="
            text-align: left;
            font-size: 14px;
            color: #000;
            padding: 10px 20px 0px 20px;
            flex-wrap: wrap;
          "
        >
          <van-col span="8" style="font-size: 14px; font-weight: 600"
            >协调小组：</van-col
          >
          <van-col
            span="16"
            style="font-size: 14px; font-weight: 200; padding: 0px 0px 0px 0px"
            >{{ lbxmDetail.bz }}</van-col
          >
        </van-row>
        <van-row
          type="flex"
          style="
            text-align: left;
            font-size: 14px;
            color: #000;
            padding: 10px 20px 0px 20px;
            flex-wrap: wrap;
          "
        >
          <van-col span="8" style="font-size: 14px; font-weight: 600"
            >备注：</van-col
          >
          <van-col
            span="16"
            style="font-size: 14px; font-weight: 200; padding: 0px 0px 0px 0px"
            >{{ lbxmDetail.bz2 }}</van-col
          >
        </van-row>
      </van-dialog>
      <div style="height: 100px"></div>
    </div>
  </div>
</template>

<script>
import zdqdUser from '../api/zdqd'
import { parseTime } from '../utils/index'
import { getDict } from '../api/zdqd.js'
export default {
  name: 'Lst',
  data() {
    return {
      selectYearsColumns: [],
      selectYearLbxm: process.env.VUE_SELECT_YEAR,
      selectYearZhxm: process.env.VUE_SELECT_YEAR,
      selectYearAllScore: process.env.VUE_SELECT_YEAR,
      // 考核得分年份
      kfdfYear: process.env.VUE_SELECT_YEAR,
      // selectYearLbxm: new Date().getFullYear(),
      // selectYearZhxm: new Date().getFullYear(),
      // selectYearAllScore: new Date().getFullYear(),
      // // 考核得分年份
      // kfdfYear:new Date().getFullYear(),
      // 名称类型 1部门 2街道
      unitType: 1,
      // 考核得分季度
      khdfQuarter: null,
      // 名称类型列表
      unitTypeList: [
        {
          name: '部门',
          value: 1,
        },
        {
          name: '街道',
          value: 2,
        },
      ],
      active: 0,
      months: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
      ],
      dateTitle: '',
      showMrzx: false,
      showScore: false,
      showScoreDetail: false,
      showDetail: {
        dept: '',
        lx: '',
        name: '',
        note: [],
        score: '',
      },
      initPersons: [],
      persons: [],
      initOkProjects: [],
      okProjects: [],
      initScoreProjects: [],
      scoreProjects: [],
      ngProjects: [],
      activeNames: '',
      seasonList: ['第一季度', '第二季度', '第三季度', '第四季度'],
      showLbxm: false,
      showlbxmDetail: false,
      lbxmDetail: {
        dept: '',
        name: '',
        sbly: [],
        id: '',
        bz: '',
        bz2: '',
      },
      lbxmItem: {},
      // 滞后项目
      activeZhxm: '',
    }
  },
  created() {
    // 通过后台配置的字典，拿到年份
    getDict('selectyear_list').then((res) => {
      res.data.content.forEach((x) => {
        this.selectYearsColumns.push(x.label)
      })
    })
    zdqdUser.getLbxm(this.selectYearLbxm).then((res) => {
      this.initOkProjects = res.data
    })
    zdqdUser.getZhxm(this.selectYearZhxm).then((res) => {
      this.ngProjects = res.data
    })
  },
  methods: {
    // 绿榜项目
    selectChangeLbxm(e) {
      zdqdUser.getLbxm(e.target.value).then((res) => {
        this.initOkProjects = res.data
      })
    },
    // 滞后项目
    selectChangeZhxm(e) {
      zdqdUser.getZhxm(e.target.value).then((res) => {
        this.ngProjects = res.data
      })
    },
    //考核得分年份选择
    selectChangeKhdf(e) {
      this.kfdfYear = e.target.value
    },
    // 考核得分类型选择
    selectChangeunitFn(e) {
      this.unitType = e.target.value
      this.clickScoreSeason(this.khdfQuarter)
    },
    showMethod(item0, item1) {
      this.showDetail.zynr = item1.zynr
      this.showDetail.name = item0.name
      this.showDetail.dept = item0.dept
      this.showDetail.score = item1.score
      this.showScoreDetail = true
    },
    showSbly(item) {
      this.lbxmDetail.name = item.name
      this.lbxmDetail.dept = item.dept
      this.lbxmDetail.sbly = item.sbly
      this.lbxmDetail.bz = item.bz
      this.lbxmDetail.bz2 = item.bz2
      this.lbxmItem = item
      this.showlbxmDetail = true
    },
    clickMethod(item) {
      if (item.pid == 0) {
        this.$router.push({
          //核心语句
          path: '/projectlist', //跳转的路径
          query: { id: item.id },
        })
      } else {
        this.$router.push({
          //核心语句
          path: '/projectdetail', //跳转的路径
          query: { id: item.id },
        })
      }
    },
    selectMonth(index) {
      var today = new Date()
      var month = parseTime(
        new Date(today.getFullYear() + '/' + (index + 1) + '/1'),
        '{y}-{m}'
      )
      this.persons = this.initPersons.filter((x) => x.month == month)
      this.dateTitle = today.getFullYear() + '年' + (index + 1) + '月'
      this.showMrzx = true
    },
    clickLbxmSeason(index) {
      this.okProjects = this.initOkProjects.filter((x) => x.quarter == index)
      this.dateTitle = this.seasonList[index - 1]
      this.showLbxm = true
    },
    clickScoreSeason(index) {
      this.khdfQuarter = index
      let params = {
        year: this.kfdfYear,
        i: this.khdfQuarter,
        type: this.unitType,
      }
      // 考核得分
      zdqdUser.ApiGetmonthscorelist(params).then((res) => {
        this.scoreProjects = res.data
      })
      this.dateTitle = index == 0 ? '全年度' : this.seasonList[index - 1]
      this.showScore = true
    },
  },
}
</script>
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.van-cell.van-field {
  background-color: #e8e8e8;
  border-radius: 8px;
}
.selectClass {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #c4c8cf;
  padding: 4px 0px 4px 0px;
}
.zhxmTitlecls {
  text-align: right;
  font-size: 14px;
  color: #999;
}
.zhxmTextCls {
  text-align: left;
}
.zhxmTextCls div {
  color: #999;
  font-weight: 700;
}
</style>
<style>
.deepMaxHeight .van-dialog__content {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Lst.vue